import React, { createContext, useState, useContext } from "react";
import util from "../services/Utility";

// Create the Context
export const FlagContext = createContext();

// Custom Hook to use the FlagContext in functional components
export const useFlagContext = () => {
  return useContext(FlagContext);
};

// Provider Component
const FlagProvider = ({ children }) => {
    const [entries, setEntries] = useState(() => {
        const storedEntries = util.decodeString(localStorage.getItem("flagEntries"));
        return storedEntries ? JSON.parse(storedEntries) : [];
      });
    
  const setFlagResponse = (response) => {
    const parsedData = response.map((item) => ({
      flagId: item.id,
      flagName: item.typeStyleValue || "UNKNOWN",
      flagColor: item.imgPath ? "#" + item.imgPath : null,
    }));
    setEntries(parsedData);
  };

  // Use useEffect to observe changes in entries
  React.useEffect(() => {
    // console.log("entries updated : " + JSON.stringify(entries));
    localStorage.setItem("flagEntries", util.encodeString(JSON.stringify(entries)));
  }, [entries]); // Runs whenever `entries` changes

  const getFlagNames = () => entries.map((entry) => entry.flagName);

  const getColorByFlagName = (flagName) => {
    const entry = entries.find((entry) => entry.flagName === flagName);
    return entry ? entry.flagColor : null;
  };

  const getFlagById = (flagId) => {
    return entries.find((entry) => entry.flagId === flagId) || null;
  };

  const getFlagByName = (flagName) => {
    return entries.find((entry) => entry.flagName === flagName) || null;
  };

  const value = {
    entries,
    setFlagResponse,
    getFlagNames,
    getColorByFlagName,
    getFlagById,
    getFlagByName,
  };

  return <FlagContext.Provider value={value}>{children}</FlagContext.Provider>;
};

export default FlagProvider;
